import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import {Section} from 'sidebar/SidebarConstants';

const SidebarActions = {
  open: (): void => {
    AppDispatcher.dispatch({
      actionType: EventConstants.SIDEBAR_OPEN,
    });
  },
  openSection: (section: Section): void => {
    AppDispatcher.dispatch({
      actionType: EventConstants.SIDEBAR_OPEN,
      section,
    });
  },
  /**
   * An action to be called whenever a new file is being rendered into the buffers that signals to the
   * SideBar to render the appropriate section.
   *
   * @param  {String} fileType The fileType of the to-be-opened files (i.e., from ModelTypeConstants)
   */
  openSectionForFileType: (fileType: string | null): void => {
    AppDispatcher.dispatch({
      actionType: EventConstants.SIDEBAR_OPEN_FOR_FILE_TYPE,
      fileType,
    });
  },
  close: (): void => {
    AppDispatcher.dispatch({
      actionType: EventConstants.SIDEBAR_CLOSE,
    });
  },
};

export default SidebarActions;
